import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { OnboardDiagnosticService } from '../../onboard-diagnostic/onboard-diagnostic.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { VideosService } from '../../videos/videos.service';
import { AdminService } from '../admin.service';
// import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-add-bulletin-for-video-tool-obd',
    templateUrl: './add-bulletin-for-video-tool-obd.component.html',
    styleUrls: ['./add-bulletin-for-video-tool-obd.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        FormsModule,
        NgStyle,
    ],
})
export class AddBulletinForVideoToolObdComponent implements OnInit, OnDestroy {

  public bulletinType = '';
  public actionType = '';
  private subscriptions: ISubscription[] = [];
  public makeList;
  public inputMake;
  public inputDate: string;
  public selDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public documentNumber = '';
  public bulletinNumber = '';
  public textareaContent = '';
  public relatedSIBs: string[] = [];
  public setDateFlag: boolean = false;

  public reactivateOrDeactivate: any;

  public isDocActive = false;

  public makeNameForApi: string;

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  // Video related variables
  public inputChannel: any;
  public channelsList = [];

  // OBD related variables
  public inputYear = '';
  public inputCategory: any;
  public engineName: any;

  // Tool report related variables
  public autoship = false;
  public warranty = false;
  public partNumber = '';
  public toolDesc = '';
  public toolLoc = '';


  public seriesList: any[];
  public seriesFilterList: any[];
  public enginesList: any[];
  public enginesFilterList: any[];
  public modelsList: any[];
  public modelsFilterList: any[];

  public documentNumbersList: any[];
  public obdCategories: any[];
  public docId: number;

  private userEmail: string;

  public errorMessage = '';
  public showAllFields: boolean = false;

  public uploadedFileName = 'No File Selected';
  public vimeoID = '';
  public uploadedFile = null;

  public pageTitle: string;

  public allObdData: any[];
  public documentOBDTitle;

  public newUploadFlag: boolean = false;
  public showAllOptionsOBD: boolean = false;
  public showAllOptionsTool: boolean = false;

  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;
  public isAdmin: boolean = false;
  public isMotorrad: boolean = false;
  public showTakata: boolean = false;


  constructor(
    private cmsNavbarService: CmsNavbarService,
    private videoService: VideosService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private modelMapService: ModelMapService,
    private route: ActivatedRoute,
    private obdService: OnboardDiagnosticService,
    private router: Router,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private changeDetectorRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService
  ) { }

  getPageTitle(): string {
    let isOdb = (this.bulletinType.toLowerCase() == 'obd') ? true : false;
    if (isOdb === false) {
      this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + this.bulletinType.charAt(0).toUpperCase() + this.bulletinType.slice(1));
    }
    if (isOdb === true) {
      this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + this.bulletinType.toUpperCase());
    }
    return this.pageTitle;
  }

  ngOnInit() {

    if (APP_SETTINGS.isMotorradAdmin === 'true') {
      this.isMotorradAdmin = true;
    }

    if (APP_SETTINGS.isRollsRoyceAdmin === 'true') {
      this.isRollsRoyceAdmin = true;
    }


    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
    }

    if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.isMotorrad = true;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.pageTitle = '';

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
      this.changeDetectorRef.markForCheck();
    });

    // this.userEmail = 'Chad.Pinson@partner.bmwgroup.com';
    this.documentNumbersList = [];
    this.obdCategories = [];
    this.seriesList = [];
    this.enginesList = [];
    this.modelsList = [];
    this.resetFields();
    this.getPageTitle();
    this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    this.actionType = this.route.snapshot.paramMap.get('actionType');
    // if (this.actionType === 'edit') {
    //   if (this.bulletinType === 'obd') {
    //     this.getOBDCOntent();
    //   } else if (this.bulletinType === 'tool') {
    //     this.subscriptions.push(this.adminService.getAllToolReportPartNumbers().subscribe(data => {
    //       this.documentNumbersList = data;
    //     }));
    //   }
    // }
    // this.router.events.subscribe(event => {
    //   this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    //   this.actionType = this.route.snapshot.paramMap.get('actionType');
    //   if (this.actionType === 'edit') {
    //     if (this.bulletinType === 'obd') {
    //       this.getOBDCOntent();
    //     } else if (this.bulletinType === 'tool') {
    //       this.subscriptions.push(this.adminService.getAllToolReportPartNumbers().subscribe(data => {
    //         this.documentNumbersList = data;
    //       }));
    //     }
    //   }
    // });
    this.subscriptions.push(this.cmsNavbarService.getAllMakeList().subscribe(data => {
      if (this.isMotorradAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'MOTORRAD'));
      }
      else if (this.isRollsRoyceAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'ROLLSROYCE'));
      } else {
        this.makeList = data.filter(make => (make['makeName'] === 'BMW' || make['makeName'] === 'MINI' || make['makeName'] === 'MOTORRAD' || make['makeName'] === 'ROLLSROYCE'));
      }
      this.changeDetectorRef.markForCheck();
    }));

    this.subscriptions.push(this.modelMapService.getAllEngines().subscribe(data => {
      this.enginesList = data;
      this.changeDetectorRef.markForCheck();
    }));

    this.subscriptions.push(this.videoService.getChannelsData().subscribe(data => {
      this.channelsList = data;
      this.changeDetectorRef.markForCheck();
    }));

    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.changeDetectorRef.markForCheck();
    }));

    this.subscriptions.push(this.modelMapService.getAllModels().subscribe(data => {
      this.modelsList = data;
      this.changeDetectorRef.markForCheck();
    }));

    this.setRandomDocNumber();
  }

  getAllVideoNumbers(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.adminService.getAllVideoNumbers(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.documentNumbersList = data;
      this.changeDetectorRef.markForCheck();
    }));
  }

  getAllToolReportNumbers(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.adminService.getAllToolReportPartNumbers(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.documentNumbersList = data;
      this.changeDetectorRef.markForCheck();
    }));
  }

  resetFields() {
    this.inputMake = null;
    this.seriesFilterList = [];
    this.enginesFilterList = [];
    this.modelsFilterList = [];
    this.relatedSIBs = [];
    this.uploadedFile = this.inputDate = '';
    this.uploadedFileName = 'No File Selected';
    this.vimeoID = '';
    this.bulletinNumber = this.documentNumber = this.textareaContent = this.tkrCode = '';
    this.isTakataRecall = false;
    this.newUploadFlag = false;
    this.documentNumber = null;
    this.makeNameForApi = undefined;
    this.showAllOptionsOBD = false;
    this.showAllOptionsTool = false;
  }

  addToSelection(listType: string, listItem: string | object) {
    listItem = listItem !== null && typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'engine':
          this.enginesFilterList.push(listItem);
          break;
        case 'series':
          this.seriesFilterList.push(listItem);
          this.inputSeries = '';
          break;
        case 'model':
          this.modelsFilterList.push(listItem);
          break;
        case 'sib':
          this.bulletinNumber = '';
          this.relatedSIBs.push(listItem as string);
          break;
      }
    }
  }

  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'engine':
        this.enginesFilterList = this.enginesFilterList.filter(item => item !== listItem);
        break;
      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem);
        break;
      case 'model':
        this.modelsFilterList = this.modelsFilterList.filter(item => item !== listItem);
        break;
      case 'sib':
        this.relatedSIBs = this.relatedSIBs.filter(item => item !== listItem);
        break;
    }
  }

  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.newUploadFlag = true;
      }
    }
  }

  analyticCallAddbulletin(bulletinType: string, makeName: string, bulletinNumber: string) {
    let userID = this.authService.getUserName();
    if (this.actionType === 'add') {
      this.analyticsService.trackNewContentAdded(userID, bulletinType, makeName, bulletinNumber, 'added');
    }
    else if (this.actionType == 'edit') {
      this.analyticsService.trackEditContentUpdated(userID, bulletinType, makeName, bulletinNumber, 'updated');
    }
  }

  submit() {
    // this.inputDate = (this.inputDate) ? this.inputDate['formatted'] : this.setDefaultDate();
    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }

    if (this.actionType === 'add') {

      this.spinnerService.show("bmwSpinner");
      if (this.bulletinType === 'video') {

        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const videoObject = {
          "videoDisplayNumber": this.documentNumber,
          "videoTitle": this.textareaContent,
          "bulletinDisplayNumber": this.relatedSIBs,
          "make": this.inputMake,
          "channel": this.inputChannel,
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "series": selectedSeries,
          "videoFileName": this.vimeoID,
          "likes": 0,
          "dislikes": 0,
          "views": 0,
        };
        this.subscriptions.push(this.adminService.createNewVideo(videoObject).subscribe(value => {
          this.errorMessage = '';
          if (value) {
            this.spinnerService.hide("bmwSpinner");
            this.resetFields();
            this.toastService.popToast('Video added');
            this.errorMessage = '';
            this.inputSeries = '';
            this.inputChannel = null;
            this.router.navigate(['/videos/home']);
            /* Upload file is not needed for vide as we wiill only entering Vimeo ID
            //uploadedFileName
            if (this.vimeoID !== 'No Vimeo ID' && this.vimeoID.length > 0) {
              const formData = new FormData();
              formData.append('videoFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.createNewVideoWithFile(formData, this.documentNumber, this.inputMake.makeName)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.resetFields();
                    this.toastService.popToast('Video added');
                    this.errorMessage = '';
                    this.inputSeries = '';
                    this.inputChannel = null;
                  }
                },
                error => {
                  this.spinnerService.hide("bmwSpinner");
                  this.errorMessage = error.error.message;
                }));
            } else {
              this.resetFields();
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('Video added');
              this.errorMessage = '';
              this.inputSeries = '';
              this.inputChannel = null;
            } */
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = error.error.message;
          }));
        this.analyticCallAddbulletin('Videos', this.inputMake.makeName, this.documentNumber);

      } else if (this.bulletinType === 'obd') {
        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const selectedEngines = this.enginesList.filter(engine => this.enginesFilterList.includes(engine['engineName']));
        const obdObj = {
          "documentNumber": this.documentNumber,
          "documentCategory": this.inputCategory,
          "engineFamily": this.engineName,
          "productionDate": this.inputYear,
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "make": this.inputMake,
          "documentFileName": this.uploadedFileName,
          "engines": selectedEngines,
          "series": selectedSeries
        };
        this.subscriptions.push(this.adminService.createNewOBD(obdObj).subscribe(value => {
          if (value) {
            this.errorMessage = '';
            if (this.uploadedFileName !== 'No File Selected' && this.uploadedFileName.length > 0) {
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.createNewOBDWithFile(formData, this.documentNumber, this.inputMake.makeName)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.toastService.popToast('OBD added');
                    this.errorMessage = '';
                    this.resetFields();
                    this.inputSeries = this.inputEngine = this.engineName = '';
                    this.inputYear = '';
                    this.inputCategory = null;
                    this.router.navigate(['/obd']);
                  }
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            } else {
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('OBD added');
              this.errorMessage = '';
              this.resetFields();
              this.inputSeries = this.inputEngine = this.engineName = '';
              this.inputYear = '';
              this.inputCategory = null;
              this.router.navigate(['/obd']);
            }
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = error.error.message;
          }));
        this.analyticCallAddbulletin(this.bulletinType, this.inputMake.makeName, this.engineName);

      } else if (this.bulletinType === 'tool') {
        this.inputCategory = "Complete Tool Report";

        //const selectedModels = this.modelsList.filter(model => this.modelsFilterList.includes(model['modelName']));
        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const toolObj = {
          "documentCategory": this.inputCategory,
          "orderPartNumber": this.documentNumber,
          "partNumber": this.partNumber,
          "bulletinDisplayNumber": this.bulletinNumber,
          "description": this.toolDesc,
          "notes": this.textareaContent,
          "autoShip": this.autoship,
          "externalMfrgToolWarranty": this.warranty,
          "documentFileName": '',
          "location": this.toolLoc,
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "make": this.inputMake,
          //"models": selectedModels
          "series": selectedSeries
        };
        this.subscriptions.push(this.adminService.createNewToolReport(toolObj).subscribe(value => {
          if (value) {
            this.errorMessage = '';
            if (this.uploadedFileName !== 'No File Selected' && this.uploadedFileName.length > 0) {
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.createNewToolReportWithFile(formData, this.documentNumber, this.inputMake.makeName)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.toastService.popToast('ToolReport added');
                    this.resetFields();
                    this.inputSeries = this.inputModel = '';
                    this.partNumber = this.toolDesc = this.toolLoc = '';
                    this.autoship = this.warranty = false;
                    this.inputCategory = null;
                    this.router.navigate(['/tool-report']);
                  }
                }, error => {
                  this.spinnerService.hide("bmwSpinner");
                  this.errorMessage = error.error.message;
                }));
            } else {
              this.spinnerService.hide("bmwSpinner");
              this.toastService.popToast('ToolReport added');
              this.resetFields();
              this.inputSeries = this.inputModel = '';
              this.partNumber = this.toolDesc = this.toolLoc = '';
              this.autoship = this.warranty = false;
              this.inputCategory = null;
              this.router.navigate(['/tool-report']);
            }
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = error.error.message;
          }));
        this.analyticCallAddbulletin(this.bulletinType, this.inputMake.makeName, this.documentNumber);
      }
    } else if (this.actionType === 'edit') {
      if (this.bulletinType === 'video') {
        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const selectedChannel = this.channelsList.filter(channel => `[${channel['channelNumber']}] ${channel['channelName']}` === this.inputChannel) ;
        const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const videoObject = {
          "id": this.docId,
          "videoDisplayNumber": this.documentNumber,
          "videoTitle": this.textareaContent,
          "bulletinDisplayNumber": this.relatedSIBs,
          "make": selectedMake,
          "channel": selectedChannel[0],
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "series": selectedSeries,
          "videoFileName": this.vimeoID,
          "likes": 0,
          "dislikes": 0,
          "views": 0,
        };
        this.spinnerService.show("bmwSpinner");
        this.subscriptions.push(this.adminService.updateVideo(videoObject).subscribe(value => {
          if (value) {

            // this.documentNumbersList = [];
            if (this.reactivateOrDeactivate === 'reactivate') {
              this.subscriptions.push(this.adminService.reactivateVideo(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.toastService.popToast('Video Reactivated');
                  this.spinnerService.hide("bmwSpinner");
                  this.errorMessage = '';
                  this.reactivateOrDeactivate = null;
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            } else if (this.reactivateOrDeactivate === 'deactivate') {
              this.subscriptions.push(this.adminService.deactivateVideo(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.toastService.popToast('Video Deactivated');
                  this.spinnerService.hide("bmwSpinner");
                  this.errorMessage = '';
                  this.reactivateOrDeactivate = null;
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            }

            this.spinnerService.hide("bmwSpinner");
            this.resetFields();
            this.inputSeries = '';
            this.errorMessage = '';
            this.toastService.popToast('Video Updated');
            this.inputChannel = null;
            this.uploadedFile = null;

            /* Commented to support Vimeo ID - not needed if not physical file
            if (this.uploadedFile !== null && this.uploadedFileName.length > 0 && this.newUploadFlag === true) {
              const formData = new FormData();
              formData.append('videoFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.updateVideoWithFile(
                formData,
                this.documentNumber,
                selectedMake.makeName
              )
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.resetFields();
                    this.inputSeries = '';
                    this.errorMessage = '';
                    this.toastService.popToast('Video Updated');
                    this.inputChannel = null;
                    this.uploadedFile = null;
                  }
                },
                error => {
                  this.spinnerService.hide("bmwSpinner");
                  this.errorMessage = error.error.message;
                }));
            } */
            // else {
            //   this.resetFields();
            //   this.inputSeries = '';
            //   this.errorMessage = '';
            //   this.toastService.popToast('Video Updated');
            //   this.inputChannel = null;
            //   this.uploadedFile = null;
            // }
          }
        }));
        this.analyticCallAddbulletin(this.bulletinType, this.makeNameForApi, this.documentNumber);
      } else if (this.bulletinType === 'obd') {
        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const selectedEngines = this.enginesList.filter(engine => this.enginesFilterList.includes(engine['engineName']));
        const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const obdObj = {
          "documentNumber": this.documentNumber,
          "documentCategory": this.inputCategory,
          "engineFamily": this.engineName || '',
          "productionDate": this.inputYear,
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "make": selectedMake,
          "documentFileName": this.uploadedFileName,
          "engines": selectedEngines,
          "series": selectedSeries,
          "id": this.docId
        };
        this.subscriptions.push(this.adminService.updateOBD(obdObj).subscribe(value => {
          this.spinnerService.show("bmwSpinner");
          if (value) {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = '';
            this.toastService.popToast('OBD updated');
            // this.documentNumbersList = [];
            if (this.reactivateOrDeactivate === 'reactivate') {
              this.subscriptions.push(this.adminService.reactivateOBD(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.spinnerService.hide("bmwSpinner");
                  this.reactivateOrDeactivate = null;
                }));
            } else if (this.reactivateOrDeactivate === 'deactivate') {
              this.subscriptions.push(this.adminService.deactivateOBD(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.spinnerService.hide("bmwSpinner");
                  this.reactivateOrDeactivate = null;
                }));
            }
            if (this.uploadedFile !== null && this.uploadedFileName.length > 0 && this.newUploadFlag === true) {
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              this.spinnerService.show("bmwSpinner");
              this.subscriptions.push(this.adminService.updateOBDWithFile(formData, this.documentNumber, selectedMake.makeName)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = '';
                    this.toastService.popToast('OBD Updated');
                    this.resetFields();
                    this.inputSeries = this.inputEngine = this.engineName = '';
                    this.inputYear = '';
                    this.inputCategory = this.uploadedFile = null;
                  }
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            } else {
              this.spinnerService.hide("bmwSpinner");
              this.errorMessage = '';
              this.toastService.popToast('OBD Updated');
              this.resetFields();
              this.inputSeries = this.inputEngine = this.engineName = '';
              this.inputYear = '';
              this.inputCategory = this.uploadedFile = null;
            }
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = error.error.message;
          }));
        this.analyticCallAddbulletin(this.bulletinType, this.makeNameForApi, this.engineName);

      } else if (this.bulletinType === 'tool') {
        //const selectedModels = this.modelsList.filter(model => this.modelsFilterList.includes(model['modelName']));
        const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const toolObj = {
          "id": this.docId,
          "documentCategory": this.inputCategory,
          "orderPartNumber": this.documentNumber,
          "partNumber": this.partNumber || null,
          "bulletinDisplayNumber": this.bulletinNumber,
          "description": this.toolDesc,
          "notes": this.textareaContent,
          "autoShip": this.autoship,
          "externalMfrgToolWarranty": this.warranty,
          "documentFileName": this.uploadedFileName,
          "location": this.toolLoc,
          "takataRecallCode": this.tkrCode,
          "takataRecallType": this.isTakataRecall,
          "releaseDate": this.inputDate,
          "make": selectedMake,
          //"models": selectedModels
          "series": selectedSeries
        };
        this.spinnerService.show("bmwSpinner");
        this.subscriptions.push(this.adminService.updateToolReport(toolObj).subscribe(value => {
          if (value) {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = '';
            // this.documentNumbersList = [];
            this.toastService.popToast('Tool report updated');
            if (this.reactivateOrDeactivate === 'reactivate') {
              this.subscriptions.push(this.adminService.reactivateToolReport(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.toastService.popToast('ToolReport Reactivated');
                  this.spinnerService.hide("bmwSpinner");
                  this.reactivateOrDeactivate = null;
                }));
            } else if (this.reactivateOrDeactivate === 'deactivate') {
              this.subscriptions.push(this.adminService.deactivateToolReport(this.documentNumber, this.userEmail, selectedMake.makeName)
                .subscribe(data => {
                  this.spinnerService.hide("bmwSpinner");
                  this.toastService.popToast('ToolReport Deactivated');
                  this.reactivateOrDeactivate = null;
                }));
            }
            if (this.uploadedFile !== null && this.uploadedFileName.length > 0 && this.newUploadFlag === true) {
              const formData = new FormData();
              formData.append('documentFile', this.uploadedFile, this.uploadedFile.name);
              this.subscriptions.push(this.adminService.updateToolReportWithFile(formData, this.documentNumber, selectedMake.makeName)
                .subscribe(data => {
                  if (data) {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = '';
                    this.resetFields();
                    this.inputSeries = this.inputModel = '';
                    this.documentNumber = this.toolDesc = this.toolLoc = '';
                    this.autoship = this.warranty = false;
                    this.inputCategory = null;
                    this.uploadedFile = null;
                  }
                },
                  error => {
                    this.spinnerService.hide("bmwSpinner");
                    this.errorMessage = error.error.message;
                  }));
            } else {
              this.spinnerService.hide("bmwSpinner");
              this.errorMessage = '';
              this.resetFields();
              this.inputSeries = this.inputModel = '';
              this.documentNumber = this.toolDesc = this.toolLoc = '';
              this.autoship = this.warranty = false;
              this.inputCategory = null;
              this.uploadedFile = null;
            }
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            this.errorMessage = error.error.message;
          }));
        this.analyticCallAddbulletin(this.bulletinType, this.makeNameForApi, this.documentNumber);
      }
    }
  }
  // functions for edit
  getVideoData(videoNumber, makeName) {
    this.spinnerService.show("bmwSpinner");
    this.subscriptions.push(this.adminService.getVideoInfo(videoNumber, makeName).subscribe(data => {
      if (data) {
        this.showAllFields = true;
        this.inputChannel = `[${data['channel']['channelNumber']}] ${data['channel']['channelName']}` ;
        this.uploadedFileName = data['videoFileName'] || this.uploadedFileName;
        this.vimeoID = this.uploadedFileName;
        this.inputDate = ' ';
        this.inputMake = data['make']['makeName'];
        this.isDocActive = data['isActive'];
        this.seriesFilterList = data['series'].length > 0 ? data['series'].map(series => series['seriesName']) : [];
        this.isTakataRecall = data['takataRecallType'];
        this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
        this.textareaContent = data['videoTitle'];
        this.relatedSIBs = data['bulletinDisplayNumber'];
        this.docId = data['id'];
        setTimeout(() => {
          this.selDate = data['releaseDate'];
          this.inputDate = data['releaseDate'];
        }, 50);
      }

      this.spinnerService.hide("bmwSpinner");
    }, error => {
      this.spinnerService.hide("bmwSpinner");
      this.errorMessage = error.error.message;
    }));
  }
  getToolReportData(docNumber) {
    this.spinnerService.show("bmwSpinner");
    this.subscriptions.push(this.adminService.getToolReportWithPartNumber(docNumber, this.makeNameForApi).subscribe(data => {
      if (data) {
        this.partNumber = data['partNumber'];
        this.bulletinNumber = data['bulletinDisplayNumber'];
        this.textareaContent = data['notes'];
        this.toolDesc = data['description'];
        this.autoship = data['autoShip'];
        this.inputMake = data['make']['makeName'];
        this.warranty = data['externalMfrgToolWarranty'];
        this.uploadedFileName = data['documentFileName'] || this.uploadedFileName;
        this.inputCategory = data['documentCategory'];
        //this.modelsFilterList = data['models'].length > 0 ? data['models'].map(model => model['modelName']) : [];
        this.seriesFilterList = data['series'].length > 0 ? data['series'].map(seriesObject => seriesObject['seriesName']) : [];
        this.isTakataRecall = data['takataRecallType'];
        this.tkrCode = this.isTakataRecall ? data['takataRecallCode'] : '';
        this.docId = data['id'];
        this.isDocActive = data['isActive'];
        this.errorMessage = '';

        setTimeout(() => {
          this.selDate = data['releaseDate'];
          this.inputDate = data['releaseDate'];
        }, 50);
      }
      this.showAllOptionsTool = true;
      this.spinnerService.hide("bmwSpinner");
    }, error => {
      this.spinnerService.hide("bmwSpinner");
      this.errorMessage = error.message;
    }));
  }
  getOBDDocNumber(docNumber) {
    // documentOBDTitle
    for (let i = 0; i < this.allObdData.length; i++) {
      if (this.allObdData[i].documentFileName == docNumber) {
        this.documentNumber = this.allObdData[i].documentNumber;
      }
    }
  }
  getOBDData(docNumber) {

    for (let i = 0; i < this.allObdData.length; i++) {
      if (this.allObdData[i].documentFileName == docNumber) {
        this.documentNumber = this.allObdData[i].documentNumber;
      }
    }

    this.spinnerService.show("bmwSpinner");
    this.subscriptions.push(this.adminService.getObdDocumentWithDocumentNumber(this.documentNumber, this.makeNameForApi).subscribe(data => {
      if (data) {
        this.inputYear = data['productionDate'];
        this.enginesFilterList = data['engines'].length > 0 ? data['engines'].map(engine => engine['engineName']) : [];
        this.seriesFilterList = data['series'].length > 0 ? data['series'].map(series => series['seriesName']) : [];
        this.isTakataRecall = data['takataRecallType'];
        this.tkrCode = data['takataRecallCode'];
        this.inputMake = data['make']['makeName'];
        this.uploadedFileName = data['documentFileName'] || this.uploadedFileName;
        this.isDocActive = data['isActive'];
        this.engineName = data['engineFamily'];
        this.docId = data['id'];
        this.inputCategory = data['documentCategory'];

        setTimeout(() => {
          this.selDate = data['releaseDate'];
          this.inputDate = data['releaseDate'];
          this.changeDetectorRef.markForCheck();
        }, 50);
      }
      this.showAllOptionsOBD = true;
      this.spinnerService.hide("bmwSpinner");
      this.changeDetectorRef.markForCheck();
    }));
  }
  setRandomDocNumber() {
    if (this.bulletinType == "obd") {
      this.documentNumber = "OD" + Math.floor(100000 + Math.random() * 900000);
      return this.documentNumber;
    } else {
      return '';
    }
  }
  getOBDCOntent(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.obdService.getAllOBDManualsForAdmin(makeName).subscribe(data => {
      if (data) {
        this.allObdData = data;
        this.obdCategories = data;
        this.spinnerService.hide('bmwSpinner');
        this.changeDetectorRef.markForCheck();
      }
    }));
  }
  populateOBDDocNumbers(category) {
    const categoryContent: any[] = this.obdCategories.filter(categoryObj => categoryObj['title'] === category);
    this.documentNumbersList = categoryContent[0]['content'].map(doc => doc['documentNumber']);
  }
  onAddRelatedSIB(bulletinNumber) {
    this.relatedSIBs.push(bulletinNumber);
  }
  formatBulletinNumber(event: any, sibOrVideo: string) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput;
    let split = 2;
    let chunk = [];
    // tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    if (sibOrVideo === 'sib') {
      tempInput = this.bulletinNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.bulletinNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.bulletinNumber = tempInput.slice(0, 8);

    } else if (sibOrVideo === 'video') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 8);

    } else if (sibOrVideo === 'part') {
      split = 3;
      tempInput = this.partNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.partNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.partNumber = tempInput.slice(0, 7);

    } else if (sibOrVideo === 'order') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\W\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        if (i >= 4) {
          split = (i == 4) ? 1 : 3;
        }
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 15);
    }
  }
  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

  private handleBrandChange() {
    let make: string;

    if (typeof this.inputMake === 'object') {
      make = this.inputMake['makeName'];
    } else {
      make = this.inputMake;
    }

    if (make === 'BMW' || make === 'MINI') {
      this.showTakata = true;
    } else if (make === 'MOTORRAD' || make === 'ROLLSROYCE') {
      this.showTakata = false;
    } else {
      this.showTakata = true;
    }
  }
}
